import styled from 'styled-components';
import { TextIcon } from '@landlord-tech/ui-kit-opp/dist/components/TextIcon';
import { TTextIconProps } from './TextIcon.types';

export const STextIcon = styled(TextIcon)<TTextIconProps>`
  &&& {
  }
`;
